import React, { useState } from "react";

import { Button, Grid, Typography } from "@mui/material";
import { RoomOutlined, SensorDoorOutlined } from "@mui/icons-material";

import { PageStandard } from "components/admin/PageStandard";
import { useUserContext } from "contexts/UserContext";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  OtherCargoDetail,
  OtherCargoDetailItem,
  emptyOtherCargo,
} from "components/forms/OtherCargoDetail";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";
import { createOtherCargo } from "api/automation";

export const CreateOtherCargo = ({ history }) => {
  const { currentSpace, currentEnvironment, token } = useUserContext();
  const setError = useSetError();

  const [cargoData, setCargoData] = useState<OtherCargoDetailItem[]>([
    { ...emptyOtherCargo },
  ]);

  const handleSubmit = async () => {
    if (cargoData?.length && currentEnvironment?.id) {
      try {
        await createOtherCargo(token, currentEnvironment.id, cargoData);
        history.goBack();
      } catch (error) {
        // @ts-expect-error
        setError(error.response.data.error);
      }
    } else {
      setError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  const handleAdd = () => {
    setCargoData((prev) => [...prev, { ...emptyOtherCargo }]);
  };

  const handleCargoUpdate = (
    updated: OtherCargoDetailItem,
    position: number
  ) => {
    if (cargoData?.length) {
      const updatedData = [...cargoData];
      updatedData.splice(position, 1, updated);
      setCargoData(updatedData);
    }
  };

  const handleCargoDelete = (position: number) => {
    const updatedData = [...cargoData];
    updatedData.splice(position, 1);
    setCargoData(updatedData);
  };

  return (
    <PageStandard title="Outras Cargas" onAdd={handleAdd}>
      <BlockStandard hideDivider>
        <Grid item container alignItems="center">
          <RoomOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentSpace?.schoolName}</Typography>
          <SensorDoorOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentEnvironment?.name}</Typography>
        </Grid>
      </BlockStandard>

      {!!cargoData?.length &&
        cargoData.map((item, position) => {
          return (
            <OtherCargoDetail
              key={position}
              data={item}
              position={position}
              onChange={(updated) => handleCargoUpdate(updated, position)}
              onDelete={() => handleCargoDelete(position)}
            />
          );
        })}

      {!!cargoData?.length && (
        <Button variant="contained" onClick={handleSubmit}>
          Atualizar dados de outras cargas
        </Button>
      )}
    </PageStandard>
  );
};
